/*
	Fecha o menu
*/
export default (state) => 
	state.aside.isOpen = false
	
